import { useEffect } from 'react';
import BranchesListHeader from '~/view/screens/BranchesManagementScreen/screens/BranchesScreen/containers/BranchesHeader/BranchesHeader';
import BranchesList from 'src/view/screens/BranchesManagementScreen/screens/BranchesScreen/containers/BranchesList/BranchesList';
import branchesStore from 'src/view/screens/BranchesManagementScreen/screens/BranchesScreen/store/branchesStore';
import ScreenTabsNavigation from '~/view/containers/ScreenTabsNavigation/ScreenTabsNavigation';
import BranchesManagementHeader from '~/view/screens/BranchesManagementScreen/components/BranchesManagementHeader/BranchesManagementHeader';

const BranchesScreen = (): JSX.Element => {
  useEffect(() => {
    branchesStore.fetchBranchesList();

    return () => {
      branchesStore.clear();
    };
  }, []);

  return (
    <>
      <BranchesManagementHeader>
        {({ navigation }) => <ScreenTabsNavigation options={navigation} showSoloOption className="mb-4" />}
      </BranchesManagementHeader>
      <BranchesListHeader />
      <BranchesList />
    </>
  );
};

export default BranchesScreen;
